import net from "../Assets/svg/icon/net.svg";

export const superToolsMenuItems = [{
    id: 3,
    menu_title: "incCredit",
    menu_icon: net,
    active: true,
    path: "/admin/tools/incCredit",
},{
    id: 2,
    menu_title: "incTime",
    menu_icon: net,
    active: true,
    path: "/admin/tools/incTime",
},{
    id: 1,
    menu_title: "discountCard",
    menu_icon: net,
    active: true,
    path: "/admin/tools/discountCard",
}]